import type { Store } from "../../../client/stores";
import { logger } from "./logging";

const log = logger.getChild("Outbrain");

let hasRunOutbrain = false;
export const setupOutbrain = (store: Store) => {
    // Ensure outbrain is included once and only once
    if (hasRunOutbrain) {
        return;
    }
    const body = document.querySelector("body");

    if (body && store.site.config.sections?.partners?.outbrain_switch) {
        hasRunOutbrain = true;
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.src = "//widgets.outbrain.com/outbrain.js";
        script.onload = () => {
            log.debug("Outbrain loaded");
        };

        script.onerror = (
            event: Event | string,
            source?: string,
            fileno?: number,
            columnNumber?: number,
            error?: Error,
        ) => {
            if (error) {
                log.debug("Outbrain could not be loaded", error.message);
            }
        };

        const img = document.createElement("img");
        img.src = "https://amplifypixel.outbrain.com/pixel?mid=004d2133385513d6a3dbfd9993b43474ab";
        img.alt = "outbrain pixel";
        img.style.display = "none";

        body.appendChild(script);
        body.appendChild(img);
    }
};
